export default {
  "pages.layouts.userLayout.title": "Lightweight Warehouse Management",
  "pages.login.pageTitle": "Sign in / Sign up",
  "pages.login.success": "Signed in",
  "pages.login.failure": "Sign in failed, please try again",
  "pages.login.email.placeholder": "Email",
  "pages.login.email.required": "Please enter your email",
  "pages.login.email.invalid": "Please enter a valid email address",
  "pages.login.brandPitch":
    "A lightweight inventory, stock and audit tool — for individuals and small teams.",
  "pages.login.heroTitle": "Run inventory with AI.\nThink. Decide.",
  "pages.login.heroSubtitle":
    "Just message LINE: \"apples, 20 in.\" AI tells you when to restock and writes your monthly report.",
  "pages.login.slogan.1": "Run inventory with AI.",
  "pages.login.slogan.2": "Just say it. It's logged.",
  "pages.login.slogan.3": "AI warns before you run out.",
  "pages.login.slogan.4": "Monthly reports, written for you.",
  "pages.login.line": "Continue with LINE",
  "pages.login.google": "Continue with Google",
  "pages.login.or": "or",
  "pages.login.socialComingSoon": "{provider} login is coming soon",
  "pages.login.privacy":
    "By continuing, you agree to our <terms>Terms of Service</terms> and <privacy>Privacy Policy</privacy>.",
  "pages.login.openMailbox.gmail": "Open Gmail ↗",
  "pages.login.openMailbox.yahooJp": "Open Yahoo! Mail ↗",
  "pages.login.openMailbox.yahoo": "Open Yahoo Mail ↗",
  "pages.login.openMailbox.icloud": "Open iCloud Mail ↗",
  "pages.login.openMailbox.outlook": "Open Outlook ↗",
  "pages.login.code.send": "Continue with email",
  "pages.login.code.placeholder": "6-digit verification code",
  "pages.login.code.required": "Please enter the verification code",
  "pages.login.code.invalid": "Please enter 6 digits",
  "pages.login.code.sent": "Verification code sent",
  "pages.login.code.sentTo": "Enter the verification code we sent to {email}",
  "pages.login.code.sendFailed": "Failed to send verification code",
  "pages.login.code.resendIn": "Resend available in {seconds}s",
  "pages.login.code.resend": "Resend code",
  "pages.login.continue": "Continue",
  "pages.login.changeEmail": "← Change email",
  "pages.login.method.email": "Email",
  "pages.login.method.password": "Account & Password",
  "pages.login.username.placeholder": "Username or email",
  "pages.login.username.required": "Please enter your username or email",
  "pages.login.password.placeholder": "Password",
  "pages.login.password.required": "Please enter your password",
  "pages.login.password.submit": "Sign in",
  "pages.404.subTitle": "Sorry, the page you visited does not exist",
  "pages.404.buttonText": "Back to Home",
  "pages.502.title": "Cannot reach the server",
  "pages.502.subTitle": "The server is not responding right now. Please try again in a moment.",
  "pages.502.buttonText": "Reload",
  "pages.oauth.title": "Signing in…",
  "pages.oauth.processing": "Signing in…",
  "pages.oauth.success": "Signed in",
  "pages.oauth.fetchUserFailed": "Failed to load user info",
  "pages.oauth.backToLogin": "Back to login",
  "pages.oauth.error.stateMismatch": "Invalid authentication state. Please try again.",
  "pages.oauth.error.googleFailed": "Google sign-in failed. Please try again.",
  "pages.oauth.error.disabled": "This account has been disabled.",
  "pages.oauth.error.closing":
    "This account is being closed. Contact support to restore it.",
  "pages.oauth.error.generic": "Sign-in failed. Please try again later.",

  // Common
  "common.action": "Action",
  "common.edit": "Edit",
  "common.delete": "Delete",
  "common.cancel": "Cancel",
  "common.confirm": "Confirm",
  "common.save": "Save",
  "common.retry": "Retry",
  "common.created": "Created successfully",
  "common.updated": "Updated successfully",
  "common.deleted": "Deleted successfully",
  "common.createdAt": "Created At",
  "common.reset": "Reset",
  "common.export": "Export",
  "common.exporting": "Exporting...",
  "common.export.success": "Export successful",
  "common.export.noData": "No data to export",
  "common.import": "Import",
  "common.upload": "Click to Upload",

  // Product
  "product.title": "Products",
  "product.name": "Product Name",
  "product.name.placeholder": "Enter product name",
  "product.name.required": "Product name is required",
  "product.sku": "SKU",
  "product.sku.placeholder": "Enter SKU (optional)",
  "product.tags": "Tags",
  "product.tags.placeholder": "Press Enter to add tags",
  "product.threshold": "Low Stock Threshold",
  "product.threshold.placeholder": "Enter threshold",
  "product.threshold.invalid": "Please enter a valid threshold",
  "product.threshold.tooltip":
    "If the product has variants, this value is not used for status — variants use their own thresholds. It only acts as the default when creating new variants.",
  "product.threshold.parentDefault": "Default {value}",
  "product.status": "Status",
  "product.status.active": "Active",
  "product.status.archived": "Archived",
  "product.create": "New Product",
  "product.create.manual": "Manual Entry",
  "product.edit": "Edit Product",
  "product.archive": "Archive",
  "product.unarchive": "Restore",
  "product.archived": "Archived",
  "product.unarchived": "Restored",
  "product.delete.confirm": "Are you sure you want to delete this product?",
  "product.imageUrl": "Product Image",
  "product.specSize": "Spec Size",
  "product.specSize.placeholder": "e.g. 58*36*16",
  "product.remark": "Remark",
  "product.remark.placeholder": "Enter remark (optional)",
  "product.contact": "Contact",
  "product.contact.placeholder": "Select contact (optional)",
  "product.unit": "Unit",
  "product.barcode": "Barcode",
  "product.unitPrice": "Unit Price",
  "product.unitPrice.placeholder": "Enter unit price (optional)",
  "product.detail": "Product Detail",
  "product.specDetail": "Spec Detail",
  "product.notFound": "Product not found",
  "product.recentTransactions": "Recent Stock In/Out Records",
  "product.batchThreshold": "Batch Set Threshold",
  "product.batchThreshold.desc":
    "Set low stock threshold for {count} selected products:",
  "product.image.hint": "Up to 3 images",
  "product.spec": "Specification",
  "product.spec.add": "Add Spec",
  "product.spec.name": "Spec Name",
  "product.spec.list": "Specifications",
  "product.spec.images": "Spec Images",
  "product.parentProduct": "Parent Product",
  "product.hasSpecs": "Has Specs",
  "product.noSpecs": "No specifications",
  "product.specCount": " specs",
  "product.specsColumn": "Variants",
  "product.spec.select": "Please select a specification",
  "product.delete.hasChildren":
    "This product has specifications, please delete them first",

  // Stock
  "stock.title": "Inventory",
  "stock.quantity": "Quantity",
  "stock.status": "Stock Status",
  "stock.status.normal": "Normal",
  "stock.status.low": "Low Stock",
  "stock.status.out": "Out of Stock",
  "stock.updatedAt": "Last Updated",
  "stock.history.view": "History",
  "stock.history.title": "Stock Change History",
  "stock.history.type": "Type",
  "stock.history.quantity": "Change",
  "stock.history.type.inventoryCheck": "Inventory Check",
  "stock.history.type.manual": "Manual Adjustment",
  "stock.history.total": "{total} records",
  "stock.count": "Count",
  "stock.count.start": "Start Counting",
  "stock.count.started": "Counting started",
  "stock.count.banner":
    "Counting · {date} · {count} counted · {variance} with variance",
  "stock.count.status": "Count Status",
  "stock.count.uncounted": "Not counted",
  "stock.count.counted": "Counted {qty}",
  "stock.count.title": "Count Entry",
  "stock.count.saved": "Saved",
  "stock.count.noNext": "No more uncounted products",
  "stock.count.noSpecs": "This product has no specs to count",
  "stock.count.loadFailed": "Failed to load stocktake data",
  "stock.count.loadFailed.desc":
    "The current count status may be inaccurate. Counting is temporarily disabled so already-entered quantities are not overwritten. Please retry.",

  // Transaction (Stock In/Out)
  "transaction.title": "Stock In/Out",
  "transaction.operation": "Stock Operation",
  "transaction.tab.register": "Register",
  "transaction.tab.history": "History",
  "transaction.batch.title": "Stock In/Out",
  "transaction.batch.items": "Product Items",
  "transaction.batch.addProduct": "Add Product",
  "transaction.batch.empty": "Add at least one product with a quantity",
  "transaction.batch.empty.hint": "No products yet. Click \"Add Product\" to start",
  "transaction.batch.duplicate": "This item is already in the list",
  "transaction.batch.itemCount": "Items",
  "transaction.batch.totalQty": "Total Qty",
  "transaction.contact.placeholder": "Select a contact (optional)",
  "transaction.history.bySlip": "By Slip",
  "transaction.history.byDetail": "By Detail",
  "transaction.slip.void.confirm": "Void this entire slip (all items)?",
  "transaction.productInfo": "Product Info",
  "transaction.type": "Type",
  "transaction.type.in": "Inbound",
  "transaction.type.out": "Outbound",
  "transaction.quantity": "Quantity",
  "transaction.quantity.required": "Please enter quantity",
  "transaction.contact": "Contact",
  "transaction.remark": "Remark",
  "transaction.remark.placeholder": "Enter remark (optional)",
  "transaction.status": "Status",
  "transaction.normal": "Normal",
  "transaction.voided": "Voided",
  "transaction.void": "Void",
  "transaction.void.confirm":
    "Void this transaction? A reverse record will be created to restore stock.",
  "transaction.void.success": "Voided",
  "transaction.in": "Inbound",
  "transaction.out": "Outbound",
  "transaction.in.submit": "Confirm Inbound",
  "transaction.out.submit": "Confirm Outbound",
  "transaction.in.success": "Inbound successful",
  "transaction.out.success": "Outbound successful",
  "transaction.product.required": "Please select a product",
  "transaction.specList": "Spec List",
  "transaction.specName": "Spec Name",
  "transaction.productSpecName": "Product / Spec Name",
  "transaction.specTag": "Spec",
  "transaction.specInfo": "Spec Info",
  "transaction.currentStock": "Current Stock",
  "transaction.transactionQty": "Quantity",
  "transaction.referenceNo": "Reference No.",
  "transaction.referenceNo.placeholder": "Enter reference number",
  "transaction.transactionDate": "Transaction Date",
  "transaction.remainingStock": "Remaining Stock",
  "transaction.unitPrice": "Unit Price",
  "transaction.operator": "Operator",
  "transaction.history": "Transaction History",
  "transaction.selectProduct": "Select Product",
  "transaction.select": "Select",
  "transaction.addProduct": "Add Product",
  "transaction.searchProduct": "Search product name",
  "transaction.submit": "Submit",
  "transaction.clearCancel": "Clear/Cancel",
  "transaction.selectProductHint": "Please select a product first",
  "transaction.notSet": "Not set",
  "transaction.search.productName": "Search product name",
  "transaction.search.dateRange": "Date Range",
  "transaction.search.stockRange": "Stock",
  "transaction.search.min": "Min",
  "transaction.search.max": "Max",

  // Dashboard
  "dashboard.title": "Dashboard",
  "dashboard.totalProducts": "Total Products",
  "dashboard.totalStock": "Total Stock",
  "dashboard.todayIn": "Today Inbound",
  "dashboard.todayOut": "Today Outbound",
  "dashboard.lowStockAlert": "Low Stock Alerts",
  "dashboard.recentTransactions": "Recent Activity",
  "dashboard.unit": "items",
  "dashboard.items": "pcs",
  "dashboard.vsYesterday": "vs yesterday",
  "dashboard.lowStockCount": "Low Stock",
  "dashboard.outOfStockCount": "Out of Stock",
  "dashboard.txTrend": "Transaction Trend",
  "dashboard.stockDistribution": "Stock Status",
  "dashboard.topProducts": "Top Products by Volume",
  "dashboard.7days": "7 Days",
  "dashboard.14days": "14 Days",
  "dashboard.30days": "30 Days",
  "dashboard.viewAll": "View All",
  "dashboard.noLowStock": "No low stock products",
  "dashboard.outOfStockAlert": "Needs attention",
  "dashboard.noOutOfStock": "No out-of-stock items",
  "dashboard.subtitle": "Inventory status and action items at a glance",
  "dashboard.kpi.title": "Inventory summary",
  "dashboard.kpi.products": "Products",
  "dashboard.kpi.outOfStock": "Out of Stock",
  "dashboard.kpi.lowStock": "Low Stock",
  "dashboard.kpi.monthOutbound": "Outbound This Month",
  "dashboard.actions.title": "Needs Action",
  "dashboard.actions.count": "{count}",
  "dashboard.actions.viewAll": "View All",
  "dashboard.actions.empty": "Nothing to handle",
  "dashboard.actions.tag.check": "Stock Check",
  "dashboard.actions.checkOverdue.empty": "No stock check records yet",
  "dashboard.actions.checkOverdue.days": "Stock check overdue {days} days",
  "dashboard.actions.tag.out": "Out",
  "dashboard.actions.tag.low": "Low",
  "dashboard.actions.detail.remaining": "Left {qty}",
  "dashboard.actions.detail.remainingThreshold": "Left {qty} / Threshold {threshold}",
  "dashboard.ai.bind.title": "Connect LINE to receive AI suggestions",
  "dashboard.ai.bind.desc": "Just send messages like \"Apple inbound 20\" to LINE. AI pushes daily replenishment suggestions.",
  "dashboard.ai.bind.cta": "Connect",
  "dashboard.ai.recommend.title": "Today's AI Recommendations",
  "dashboard.ai.recommend.count": "{count}",
  "dashboard.ai.recommend.viewAll": "View All",
  "dashboard.ai.urgency.high": "Urgent",
  "dashboard.ai.urgency.medium": "Attention",
  "dashboard.ai.urgency.low": "Preventive",
  "dashboard.ai.product.unknown": "(Unspecified product)",
  "dashboard.ai.recommend.qtyHint": "suggested / Stock {stock}",

  // Contact
  "contact.title": "Contacts",
  "contact.name": "Name",
  "contact.name.required": "Please enter contact name",
  "contact.type": "Type",
  "contact.type.placeholder": "Press Enter to add type tags",
  "contact.type.tooltip": "Free-form tags. E.g. Supplier, Customer, Carrier — used to classify contacts.",
  "contact.remark": "Remark",
  "contact.create": "New Contact",
  "contact.edit": "Edit Contact",
  "contact.delete.confirm": "Are you sure you want to delete this contact?",

  // Batch

  // Inventory Check
  "inventoryCheck.title": "Inventory Check",
  "inventoryCheck.date": "Check Date",
  "inventoryCheck.status": "Status",
  "inventoryCheck.status.open": "In Progress",
  "inventoryCheck.status.completed": "Completed",
  "inventoryCheck.status.voided": "Voided",
  "inventoryCheck.completedAt": "Completed At",
  "inventoryCheck.view": "View",
  "inventoryCheck.detail": "Check Detail",
  "inventoryCheck.items": "Check Items",
  "inventoryCheck.bookQty": "Book Quantity",
  "inventoryCheck.actualQty": "Actual Quantity",
  "inventoryCheck.difference": "Difference",
  "inventoryCheck.complete": "Complete Check",
  "inventoryCheck.complete.confirm":
    "Complete this check? Stock adjustments will be generated.",
  "inventoryCheck.complete.noItems": "Count at least one product from Inventory first",
  "inventoryCheck.completed": "Check completed",
  "inventoryCheck.void": "Void",
  "inventoryCheck.void.confirm": "Are you sure you want to void this check?",
  "inventoryCheck.voided": "Check voided",
  "inventoryCheck.notFound": "Check not found",
  "inventoryCheck.inputActualQty": "Enter Actual Quantity",
  "inventoryCheck.actualQty.empty": "Not entered",
  "inventoryCheck.actualQty.required":
    "Please enter the actual quantity; it cannot be blank",
  "inventoryCheck.continueActive": "Continue Open Check",
  "inventoryCheck.active.viewSheet": "View Check Sheet",
  "inventoryCheck.active.completeNow": "Complete Check",
  "inventoryCheck.matchBook": "Match Book Qty",
  "inventoryCheck.saveAndNext": "Save & Next",
  "inventoryCheck.removeItem": "Undo This Item",
  "inventoryCheck.removed": "Count for this product has been undone",
  "inventoryCheck.progress": "Counted Products",
  "inventoryCheck.varianceCount": "Items with Variance",
  "inventoryCheck.varianceTotal": "Total Variance",
  "inventoryCheck.variance.match": "Match",
  "inventoryCheck.drift.title": "Book quantity changed for some products",
  "inventoryCheck.drift.desc":
    "The following products had stock movements during the count. Stock has been adjusted by the counted variance — please review:",
  "inventoryCheck.currentQty": "Current Stock",
  "inventoryCheck.item.search": "Search product / SKU",
  "inventoryCheck.items.loadFailed": "Failed to load count items",
  "inventoryCheck.items.loadFailed.desc":
    "This list may be incomplete. Voiding is temporarily disabled so you don't discard a sheet that actually has data. Please retry.",
  "inventoryCheck.item.delete": "Delete",
  "inventoryCheck.item.deleted": "Check item deleted",
  "inventoryCheck.item.delete.confirm":
    "Are you sure you want to delete this check item?",
  "inventoryCheck.goStockCount": "Count from Inventory",
  "inventoryCheck.export": "Export",
  "inventoryCheck.export.filename": "Stocktake",
  "inventoryCheck.export.failed": "Export failed, please try again",
  "inventoryCheck.itemCount": "Counted Items",
  "inventoryCheck.list.hint": "Counting happens in Inventory; this is the ledger",
  "inventoryCheck.complete.result":
    "Check completed, {count} products adjusted",

  // Settings
  "settings.tab.account": "Account",
  "settings.tab.security": "Security",
  "settings.tab.business": "Business",
  "settings.tab.subscription": "Subscription",
  "settings.account.info": "Account Info",
  "settings.account.username": "Username",
  "settings.account.tenant": "Tenant ID",
  "settings.account.userCode": "User ID",
  "settings.account.createdAt": "Registered",
  "lang.ja-JP": "Japanese",
  "lang.en-US": "English",
  "lang.zh-CN": "Simplified Chinese",
  "lang.zh-TW": "Traditional Chinese",
  "settings.account.displayName": "Display Name",
  "settings.account.displayNamePlaceholder": "Enter a display name",
  "settings.account.displayNameHint":
    "When set, it is shown instead of your account",
  "settings.account.displayNameEdit": "Change",
  "settings.account.displayNameSuccess": "Display name updated",
  "settings.password.title": "Change Password",
  "settings.password.changeDesc":
    "Change your password with an email verification code — no current password needed.",
  "settings.password.old": "Current Password",
  "settings.password.new": "New Password",
  "settings.password.confirm": "Confirm New Password",
  "settings.password.minLength": "Password must be at least 6 characters",
  "settings.password.mismatch": "Passwords do not match",
  "settings.password.submit": "Change Password",
  "settings.password.success": "Password changed successfully",
  "settings.password.code": "Verification code",
  "settings.password.codePlaceholder": "6-digit code",
  "settings.password.sendCode": "Send code",
  "settings.password.codeResendIn": "Resend in {seconds}s",
  "settings.password.codeSent": "Verification code sent",
  "settings.password.codeSentTo": "A code will be sent to {email}",
  "settings.password.codeInvalid": "Please enter a 6-digit code",
  "settings.business.title": "Business Settings",
  "settings.business.defaultThreshold": "Default Low Stock Threshold",
  "settings.business.defaultThreshold.tip":
    "Default low stock threshold when creating new products",
  "settings.business.save": "Save Settings",
  "settings.fieldVisibility.title": "Field Visibility",
  "settings.fieldVisibility.desc":
    "Toggle fields on or off — list and forms adapt automatically. Hidden fields disappear from input forms, existing data is preserved.",
  "settings.fieldVisibility.updated": "Updated",
  "settings.fieldVisibility.entity.product": "Product",
  "settings.fieldVisibility.field.product.sku": "SKU",
  "settings.fieldVisibility.field.product.specSize": "Spec Size",
  "settings.fieldVisibility.field.product.contact": "Contact",
  "settings.fieldVisibility.field.product.unit": "Unit",
  "settings.fieldVisibility.field.product.barcode": "Barcode",
  "settings.fieldVisibility.field.product.unitPrice": "Unit Price",
  "settings.fieldVisibility.entity.transaction": "Transaction Records",
  "settings.fieldVisibility.field.transaction.unitPrice": "Transaction Unit Price",
  "settings.tab.app": "App Settings",
  "settings.app.title": "App Customization",
  "settings.app.icon": "App Icon",
  "settings.app.icon.desc":
    "Upload a custom icon for your mobile app. Recommended: 1024×1024 px PNG image.",
  "settings.app.icon.upload": "Upload Icon",
  "settings.app.icon.change": "Change Icon",
  "settings.app.icon.delete": "Delete Icon",
  "settings.app.icon.deleteConfirm":
    "Are you sure you want to delete the current icon?",
  "settings.app.icon.requirement":
    "PNG format, square, min 512×512 px recommended",
  "settings.app.icon.success": "Icon updated successfully",
  "settings.app.icon.deleteSuccess": "Icon deleted",
  "settings.app.icon.sizeError":
    "Image must be square and at least 512×512 pixels",
  "settings.subscription.title": "Current Subscription",
  "settings.subscription.plan": "Plan",
  "settings.subscription.maxProducts": "Max Products",
  "settings.subscription.maxTransactions": "Max Monthly Transactions",
  "settings.subscription.perMonth": " /month",

  // Feedback
  "feedback.title": "Feedback",
  "feedback.submit": "Submit",
  "feedback.submit.success": "Thanks for your feedback, we'll review it soon",
  "feedback.category": "Category",
  "feedback.category.bug": "Bug",
  "feedback.category.suggestion": "Suggestion",
  "feedback.category.feature": "Feature Request",
  "feedback.category.dissatisfied": "Dissatisfied",
  "feedback.content": "Feedback",
  "feedback.content.placeholder": "Describe your issue or suggestion...",
  "feedback.content.required": "Please enter your feedback",
  "feedback.screenshot": "Screenshot (optional)",
  "feedback.screenshot.add": "Screenshot",
  "feedback.screenshot.typeError": "Only image files are allowed",
  "feedback.screenshot.sizeError": "Image size cannot exceed 2MB",
  "feedback.contactEmail": "Contact Email (optional)",
  "feedback.contactEmail.placeholder": "So we can get back to you",
  "feedback.contactEmail.invalid": "Please enter a valid email address",

  // NPS Survey
  "nps.title": "How likely are you to recommend this product to a friend?",
  "nps.subtitle": "0 = Not at all likely, 10 = Extremely likely",
  "nps.unlikely": "Not likely",
  "nps.likely": "Very likely",
  "nps.comment.placeholder": "Anything you'd like to tell us? (optional)",
  "nps.thanks": "Thanks for your feedback!",

  // Subscription & Upgrade
  "subscription.unlimited": "Unlimited",
  "subscription.upgrade.title": "Upgrade to Pro",
  "subscription.upgrade.desc":
    "Unlock all features and boost your productivity",
  "subscription.upgrade.button": "Upgrade Now",
  "subscription.upgrade.success": "Upgrade successful",
  "subscription.upgrade.feature.export": "Export to Excel / CSV",
  "subscription.upgrade.feature.unlimited":
    "Unlimited products and transactions",
  "subscription.upgrade.feature.stats": "Basic statistics and analytics",

  // Pricing
  "pricing.title": "Choose Your Plan",
  "pricing.subtitle": "Start free, upgrade anytime to unlock more features",
  "pricing.monthly": "Monthly",
  "pricing.annual": "Annual",
  "pricing.save": "Save {percent}%",
  "pricing.free": "Free",
  "pricing.freeDesc": "Get started with basic warehouse management",
  "pricing.proDesc": "Unlock all features with unlimited usage",
  "pricing.upgradeNow": "Upgrade Now",
  "pricing.currentPlan": "Current Plan",
  "pricing.currentPlanBtn": "Current Plan",
  "pricing.downgrade": "Downgrade",
  "pricing.recommended": "Recommended",
  "pricing.perMonth": "mo",
  "pricing.billedAnnually": "Billed annually at {amount}",
  "pricing.note":
    "All plans include a 14-day free trial. No credit card required.",
  "pricing.noPriceConfig":
    "No pricing available at the moment, please try again later",
  "pricing.checkoutFailed":
    "Unable to redirect to checkout, please try again later",
  "pricing.unlimited": "Unlimited",
  "pricing.feature.products": "Product management",
  "pricing.feature.transactions": "Transaction records",
  "pricing.feature.stockManagement": "Stock management",
  "pricing.feature.inventoryCheck": "Inventory check",
  "pricing.feature.export": "Export to Excel / CSV",
  "pricing.feature.statistics": "Statistics and analytics",
  "pricing.feature.scan": "Barcode scanning",

  // Settings - Subscription Management
  "settings.subscription.status": "Status",
  "settings.subscription.nextBilling": "Next Billing Date",
  "settings.subscription.viewPlans": "View Plans",
  "settings.subscription.changePlan": "Change Plan",
  "settings.subscription.manageBilling": "Manage Billing",
  "settings.subscription.cancel": "Cancel Subscription",
  "settings.subscription.cancelConfirmTitle": "Cancel Subscription?",
  "settings.subscription.cancelConfirmDesc":
    "You can still use Pro features until the end of your current billing period. After that, your plan will be downgraded to Free.",
  "settings.subscription.confirmCancel": "Confirm Cancellation",
  "settings.subscription.cancelSuccess":
    "Subscription cancelled. Pro features remain until the end of your billing period.",
  "settings.subscription.portalFailed":
    "Unable to open billing portal, please try again later",
  "settings.subscription.gracePeriodWarning": "Payment Failed",
  "settings.subscription.gracePeriodDesc":
    "Your subscription payment was unsuccessful. Please update your payment method before {date} to avoid being downgraded to the Free plan.",
  "settings.subscription.trialRemaining": "{days} days remaining in trial",

  // ─── Smart Analytics ──────────────────────────────────────────
  "analytics.title": "Smart Analytics",
  "analytics.shipmentTrend": "Shipment Trend",
  "analytics.replenishment": "Replenishment Suggestions",
  "analytics.productAnalysis": "Product Analysis",
  "analytics.movingAverage": "Moving Average",
  "analytics.periodicity": "Periodicity",
  "analytics.granularity.day": "Daily",
  "analytics.granularity.week": "Weekly",
  "analytics.granularity.month": "Monthly",
  "analytics.timeRange": "Time Range",
  "analytics.tags": "Tags",
  "analytics.includeInbound": "Show Inbound",
  "analytics.outbound": "Outbound",
  "analytics.inbound": "Inbound",
  "analytics.last30days": "Last 30 days",
  "analytics.last90days": "Last 90 days",
  "analytics.custom": "Custom",
  "analytics.items": "items",
  "analytics.days": "days",
  "analytics.dailyOut": "Daily Outbound",
  "analytics.ma7": "7-day MA",
  "analytics.ma14": "14-day MA",
  "analytics.dow.1": "Mon",
  "analytics.dow.2": "Tue",
  "analytics.dow.3": "Wed",
  "analytics.dow.4": "Thu",
  "analytics.dow.5": "Fri",
  "analytics.dow.6": "Sat",
  "analytics.dow.7": "Sun",
  "analytics.peakDay": "Peak Day",
  "analytics.avgOut": "Avg Outbound",
  "analytics.urgency": "Urgency",
  "analytics.urgency.all": "All",
  "analytics.urgency.immediate": "Restock Now",
  "analytics.urgency.today": "Today",
  "analytics.urgency.thisWeek": "This Week",
  "analytics.urgency.twoWeeks": "Within 2 Weeks",
  "analytics.urgency.noAction": "No Action",
  "analytics.currentStock": "Current Stock",
  "analytics.dailyAvgOut": "Avg Daily Out",
  "analytics.estimatedDaysLeft": "Days Left",
  "analytics.suggestedQuantity": "Suggested Qty",
  "analytics.insufficientData": "Collecting Data",
  "analytics.insufficientDataDesc":
    "More shipment records are needed to generate analytics. Keep using the system.",
  "analytics.insufficientDataCount": "{count} products lack sufficient data",
  "analytics.selectProduct": "Select a product for detailed analysis",
  "analytics.viewAnalysis": "View Analysis",
  "analytics.formulaNote": "Calculation Notes",
  "analytics.perDay": "items/day",
  "analytics.aboutDays": "~{days} days",

  // --- Logout ---
  "settings.account.logout": "Log Out",
  "settings.account.logoutDesc": "Sign out of your account. You'll need to log in again next time.",
  "settings.account.logoutConfirmTitle": "Log out?",

  // --- Account Deletion ---
  "settings.account.dangerZone": "Danger Zone",
  "settings.account.deleteAccount": "Delete Account",
  "settings.account.deleteAccountDesc":
    "After deletion, your account will be permanently removed after 30 days. You can restore it anytime during this period by logging in.",
  "settings.account.deleteConfirmTitle": "Confirm Account Deletion?",
  "settings.account.deleteConfirmDesc":
    "Enter your password to confirm. After deletion you will be logged out. You can restore within 30 days by logging in.",
  "settings.account.deleteConfirmPassword": "Enter password",
  "settings.account.deleteConfirmEmailDesc":
    "Enter your account email {email} to confirm. After deletion you will be logged out. You can restore within 30 days by logging in.",
  "settings.account.deleteConfirmEmailRequired": "Please enter your account email",
  "settings.account.deleteConfirmEmailMismatch":
    "Email does not match your account",
  "settings.account.deleteDataNotice":
    "After 30 days, the following data will be permanently erased and cannot be recovered",
  "settings.account.deleteDataItem.records": "Inbound / outbound records",
  "settings.account.deleteDataItem.stock": "Stock records",
  "settings.account.deleteDataItem.products": "Products",
  "settings.account.deleteDataItem.user": "Account information",
  "settings.account.deleteSuccess": "Account deletion request submitted",

  // --- Account Recovery ---
  "accountClosing.title": "Account Closing",
  "accountClosing.desc":
    "Your account deletion is pending. You have {days} days left to restore it. After that, all data will be permanently deleted.",
  "accountClosing.restore": "Restore Account",
  "accountClosing.restoreConfirmTitle": "Restore Account?",
  "accountClosing.restoreConfirmPassword":
    "Enter password to confirm restoration",
  "accountClosing.restoreConfirmEmail":
    "Enter your account email {email} to confirm restoration",
  "accountClosing.restoreSuccess": "Account restored. Welcome back!",
  "accountClosing.logout": "Log Out",

  // Notices
  "notice.tab.system": "Notifications",
  "notice.tab.todo": "To-Do",
  "notice.empty": "No notifications",
  "notice.todo.empty": "No to-do items",
  "notice.readAll": "Mark all as read",
  "notice.markSelectedRead": "Mark as read",
  "notice.selected": "{count} selected",
  "notice.viewAll": "View All",

  "notice.col.content": "Content",
  "notice.col.time": "Received",
  "notice.col.type": "Type",
  "notice.type.notice": "Notice",
  "notice.type.announcement": "Announcement",
  "notice.detail.title": "Notification Detail",
  "notice.pagination.total": "{total} total",

  // Team invitations
  "invitation.inbox.title": "Pending invitations",
  "invitation.inbox.line": "{inviter} invited you to join the \"{team}\" team",
  "invitation.inbox.expiresAt": "Expires {date}",
  "invitation.accept": "Accept",
  "invitation.decline": "Decline",
  "invitation.declineConfirm": "Decline this invitation?",
  "invitation.acceptSuccess": "Joined \"{team}\". Switch teams from the top-right.",

  // Settings - Notices
  "settings.tab.notices": "Notifications",
  "settings.notices.title": "Notifications",

  // Settings - Team Management
  "settings.tab.team": "Team",
  "team.title": "Team Members",
  "team.invite": "Invite",
  "team.invite.title": "Invite a member",
  "team.invite.email": "Email",
  "team.invite.emailInvalid": "Please enter a valid email",
  "team.invite.displayName": "Display name (optional)",
  "team.invite.displayName.tip": "Used as the default name once they accept",
  "team.invite.message": "Message (optional)",
  "team.invite.checking": "Checking email…",
  "team.invite.alreadyMember": "This email is already a member of this team",
  "team.invite.alreadyPending": "This email already has a pending invitation. You can resend it.",
  "team.invite.accountExists": "This email is registered with Stockware. They will join as a member after accepting.",
  "team.invite.accountNew": "They will sign up with this email and join the team",
  "team.invite.success": "Invitation sent",
  "team.invite.resend": "Resend",
  "team.invite.resendSuccess": "Invitation resent",
  "team.invite.revoke": "Revoke",
  "team.invite.revokeConfirm": "Revoke this invitation?",
  "team.invite.col.email": "Email",
  "team.invite.col.expiresAt": "Expires",
  "team.invite.col.createdAt": "Sent",
  "team.invitations.title": "Pending invitations",
  "teamSwitcher.title": "Switch team",
  "teamSwitcher.switched": "Switched to \"{team}\"",
  "team.col.displayName": "Display Name",
  "team.col.username": "Username",
  "team.col.role": "Role",
  "team.col.status": "Status",
  "team.role.owner": "Primary",
  "team.role.member": "Member",
  "team.status.active": "Active",
  "team.status.disabled": "Disabled",
  "team.status.invited": "Invited",
  "team.edit": "Edit",
  "team.edit.success": "Member info updated",
  "team.remove": "Remove",
  "team.remove.confirm":
    "Remove this member? They will no longer be able to log in.",
  "team.disable": "Disable",
  "team.enable": "Enable",
  "team.permissions": "Permissions",
  "team.permissions.title": "Edit Permissions - {name}",
  "team.permissions.selectAll": "Select All",
  "team.permissions.resetDefaults": "Reset to Defaults",
  "team.permissions.resetDefaults.confirm": "Reset to default permissions?",
  "team.permissions.save.success": "Permissions saved",
  "team.permissions.reset.success": "Permissions reset to defaults",
  "team.permissions.custom": "Custom",
  "team.permissions.default": "Default",
  "team.permissions.col.category": "Category",
  "team.permissions.col.target": "Target",
  "team.permissions.col.permissions": "Permissions",
  "team.permissions.module.warehouse": "Warehouse",
  "team.permissions.module.smart_analytics": "Smart Analytics",
  "team.permissions.group.product": "Products",
  "team.permissions.group.stock": "Inventory",
  "team.permissions.group.transaction": "Transactions",
  "team.permissions.group.inventory-check": "Inventory Check",
  "team.permissions.group.contact": "Contacts",
  "team.permissions.group.expense": "Expenses",
  "team.permissions.group.income": "Income",
  "team.permissions.group.analytics": "Analytics",
  "team.permissions.action.list": "View",
  "team.permissions.action.add": "Add",
  "team.permissions.action.edit": "Edit",
  "team.permissions.action.delete": "Delete",
  "team.permissions.action.void": "Void",
  "team.permissions.action.export": "Export",
  "team.permissions.action.view": "View",
  "team.permissions.action.category": "Categories",

  // First Login Password Change
  "changeInitialPassword.title": "Change Initial Password",
  "changeInitialPassword.hint":
    "For account security, please change your initial password",
  "changeInitialPassword.new": "New Password",
  "changeInitialPassword.confirm": "Confirm New Password",
  "changeInitialPassword.submit": "Change Password",
  "changeInitialPassword.skip": "Skip for now",
  "changeInitialPassword.success": "Password changed successfully",

  // 14-day trial offer modal
  "trialOffer.title": "Try Pro free for 14 days",
  "trialOffer.subtitle": "No credit card required. Experience every Pro feature.",
  "trialOffer.body": "You are currently on Free. The trial unlocks all Pro features and reverts to Free automatically after 14 days. One-time only.",
  "trialOffer.accept": "Start trial now",
  "trialOffer.decline": "Not now",
  "trialOffer.successMessage": "Trial started — enjoy!",
  "trialOffer.failedMessage": "Failed to start trial. Please try again later.",

  // Public support page (/support). Submitted as the App Store "Support URL".
  "pages.support.pageTitle": "Support Center",
  "pages.support.lead":
    "Support for Stockware, the inventory management app. Please check the FAQ below first — if it does not solve your problem, feel free to contact us.",
  "pages.support.contact.heading": "Contact us",
  "pages.support.contact.intro":
    "If you run into a problem or have a feature request, email us at the address below. Telling us your device (iPhone / Android / browser), the app version, and what happened helps us respond faster.",
  "pages.support.contact.operatorLabel": "Operated by",
  "pages.support.contact.emailLabel": "Email",
  "pages.support.contact.hoursLabel": "Hours",
  "pages.support.contact.hoursValue":
    "Weekdays 10:00–18:00 JST (excluding weekends and Japanese public holidays)",
  "pages.support.contact.replyLabel": "Response time",
  "pages.support.contact.replyValue": "Within 2–3 business days",
  "pages.support.faq.heading": "Frequently asked questions",
  "pages.support.faq.q1": "I cannot sign in — the verification code email never arrives.",
  "pages.support.faq.a1":
    "You can sign in with a 6-digit code sent to your email, with a password, or with your Google account. If the code does not arrive, check your spam folder and use \"Resend code\" after 60 seconds. If it still does not arrive, please contact us.",
  "pages.support.faq.q2": "I forgot my password.",
  "pages.support.faq.a2":
    "On the sign-in screen, choose \"Sign in with email code\" to get in without a password. Once signed in, go to Profile → Settings → Change password in the app and set a new password using an email verification code. Your current password is not required.",
  "pages.support.faq.q3": "My stock numbers do not match what is on the shelf.",
  "pages.support.faq.a3":
    "Use the stocktake feature. Start a stocktake from the Inventory screen and enter the quantities you actually counted. Differences against the book quantity are calculated automatically, and confirming the stocktake creates the corresponding stock adjustments. If an item moved during the stocktake, we tell you before you confirm.",
  "pages.support.faq.q4": "I want to remove a product I added by mistake.",
  "pages.support.faq.a4":
    "Archive it from the product list or product detail screen — it disappears from the normal list while its transaction history is kept. To remove it completely, use Delete. Deletion cannot be undone, so we recommend archiving products that already have transactions.",
  "pages.support.faq.q5": "Can my staff or family use it with me?",
  "pages.support.faq.a5":
    "Yes. Go to Profile → Team and invite members by email address. Each member has a role (Owner / Member) and individually configurable permissions, and can be disabled or removed. If you belong to several teams, you can switch between them inside the app.",
  "pages.support.faq.q6": "I want to delete my account.",
  "pages.support.faq.a6":
    "You can request deletion from Profile → Settings → Delete account in the app. For 30 days after the request you can restore the account simply by signing in. After 30 days, transaction records, stock records, product records and user information are permanently deleted and cannot be recovered.",
  "pages.support.links.heading": "Related links",
  "pages.support.links.site": "Official website",
  "pages.support.links.terms": "Terms of Service",
  "pages.support.links.privacy": "Privacy Policy",
};
